import { render, staticRenderFns } from "./InfluencerSubCategoryEdit.vue?vue&type=template&id=85667272"
import script from "./InfluencerSubCategoryEdit.vue?vue&type=script&lang=js"
export * from "./InfluencerSubCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports